import { render, staticRenderFns } from "./Homefooter.vue?vue&type=template&id=16d1bb88&"
import script from "./Homefooter.vue?vue&type=script&lang=js&"
export * from "./Homefooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports